import { render, staticRenderFns } from "./courseShowList.vue?vue&type=template&id=454bd33b&scoped=true"
import script from "./courseShowList.vue?vue&type=script&lang=js"
export * from "./courseShowList.vue?vue&type=script&lang=js"
import style0 from "./courseShowList.vue?vue&type=style&index=0&id=454bd33b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454bd33b",
  null
  
)

export default component.exports